import { useEffect, useState } from "react";
import Button from "../components/Button";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import Spinner from "../components/Spinner";
import Message from "../components/Message";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { login, isLoading, isAuthenticated, loginMessage } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    if (email && password) await login(email, password);
  }

  useEffect(() => {
    if (isAuthenticated) {
      setEmail("");
      setPassword("");
      navigate("/app/home", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  if (isLoading) return <Spinner />;

  return (
    <main>
      <div className="FatForm">
        <form onSubmit={handleSubmit}>
          <div>
            <img
              src="/media/images/bunny.png"
              alt="Ceramic Bunny"
              className="LoginLogo"
            />
            {loginMessage && loginMessage !== "Logged In" && (
              <Message thisstyle="MSGError">
                {loginMessage.includes("fetch user profile")
                  ? "Login successful, but unable to load profile. Try again later."
                  : loginMessage}
              </Message>
            )}
            <label htmlFor="email">Email address</label>
            <input
              type="email"
              id="email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
          </div>

          <div>
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
          </div>

          <div>
            <Button type="primary" thisStyle="BTN_Standard">
              Login
            </Button>
            <Button
              type="secondary"
              thisStyle="BTN_Secondary"
              onClick={() => navigate("/accountcreate")}
            >
              Create an Account
            </Button>
          </div>
        </form>
      </div>
    </main>
  );
}
